import styled, { css } from 'styled-components';

export const StickyOnScrollUpWrapper = styled.div<{
  $isOut: boolean;
  $hidden: boolean;
  $showShadow: boolean;
  $animate: boolean;
  $top: number;
}>`
  width: 100%;
  position: ${({ $isOut }) => ($isOut ? 'sticky' : 'static')};
  top: ${({ $top }) => $top}px;
  z-index: 3;
  transform: translateY(${({ $hidden }) => ($hidden ? '-100%' : '0')});
  transition: ${({ $animate }) => ($animate ? 'transform 0.35s ease-out' : 'none')};

  ${({ $showShadow }) =>
    $showShadow &&
    css`
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    `}
`;
